import { Endpoints } from '@/network';
import { apiClient } from '@/services/apiClients';

export interface HardcopyProduct {
  id: number;
  name: string;
  unit_price?: number;
  thumbnail_img?: string;
  book_type?: string;
}

export interface DigitalProduct {
  id: number;
  name: string;
}

export interface HardcopyUpgradeOfferData {
  eligible: boolean;
  upgrade_price: number;
  currency_code: string;
  hardcopy_product: HardcopyProduct;
  digital_product?: DigitalProduct | null;
  source_order_id?: number;
  source_order_detail_id?: number;
  message?: string;
}

export interface HardcopyUpgradeOfferResponse {
  success: boolean;
  data: HardcopyUpgradeOfferData;
  message?: string;
}

export interface CreateHardcopyUpgradeOrderPayload {
  product_id: number;
  address_id: number;
  payment_type: 'cash_on_delivery' | 'razorpay';
  payment_account?: string;
  order_from?: string;
  source_order_id?: number;
}

export interface CreateHardcopyUpgradeOrderResponse {
  success: boolean;
  data: {
    success: boolean;
    payment_type: string;
    payment_account?: string;
    order_from?: string;
    order_id: number;
    order_code: string;
    grand_total?: number;
    amount?: number;
    currency?: string;
    razorpay_order_id?: string;
    user_name?: string;
    user_email?: string;
    user_phone?: string;
    message?: string;
  };
  message?: string;
}

export const checkHardcopyUpgradeOffer = async (
  productId: number | string,
): Promise<HardcopyUpgradeOfferResponse> => {
  const response = await apiClient.get(
    `${Endpoints.hardcopyUpgradeCheckOffer}?product_id=${productId}`,
  );
  return response?.data;
};

export const createHardcopyUpgradeOrder = async (
  payload: CreateHardcopyUpgradeOrderPayload,
): Promise<CreateHardcopyUpgradeOrderResponse> => {
  const response = await apiClient.post(
    `${Endpoints.hardcopyUpgradeCreateOrder}`,
    payload,
  );
  return response?.data;
};
